/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceDto,
  DevicesControllerActivatePathParameters,
  DevicesControllerArchivePathParameters,
  DevicesControllerChildrenPathParameters,
  DevicesControllerCreatePathParameters,
  DevicesControllerDeactivatePathParameters,
  DevicesControllerDeletePathParameters,
  DevicesControllerExecuteActionPathParameters,
  DevicesControllerExecuteRemoteActionPathParameters,
  DevicesControllerFindAllParams,
  DevicesControllerFindAllPathParameters,
  DevicesControllerFindOnePathParameters,
  DevicesControllerGetNotificationSubscriptionPathParameters,
  DevicesControllerPausePathParameters,
  DevicesControllerTimeseriesPathParameters,
  DevicesControllerUpdatePathParameters,
  ExecuteActionDto,
  NotificationSubscriptionResponseDto,
  TimeseriesFilterDto,
  UpdateDeviceDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DevicesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Get all devices for a client
   */

  findAll<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesControllerFindAllPathParameters,
    params: DevicesControllerFindAllParams,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Create a new device
   */

  create<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DevicesControllerCreatePathParameters,
    createDeviceDto: CreateDeviceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices`, createDeviceDto);
  }
  /**
   * @summary Authenticated user notification subscription status for this device incidents
   */

  getNotificationSubscription<TData = NotificationSubscriptionResponseDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerGetNotificationSubscriptionPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/notification-subscription`);
  }
  /**
   * @summary Get details of a specific device
   */

  findOne<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerFindOnePathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}`);
  }
  /**
   * @summary Delete a device
   */

  delete<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerDeletePathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}`);
  }
  /**
   * @summary Get timeseries data for a device
   */

  timeseries<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerTimeseriesPathParameters,
    timeseriesFilterDto: TimeseriesFilterDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/timeseries`, timeseriesFilterDto);
  }
  /**
   * @summary Get child devices for a specific device
   */

  children<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerChildrenPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/children`);
  }
  /**
   * @summary Update device attributes
   */

  update<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerUpdatePathParameters,
    updateDeviceDto: UpdateDeviceDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/withAttributes`, updateDeviceDto);
  }
  /**
   * @summary Execute an action on a device
   */

  executeAction<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, actionPointId }: DevicesControllerExecuteActionPathParameters,
    executeActionDto: ExecuteActionDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/execute/${actionPointId}`, executeActionDto);
  }
  /**
   * @summary Execute a remote action on a device
   */

  executeRemoteAction<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId, remoteActionPointId }: DevicesControllerExecuteRemoteActionPathParameters,
    executeActionDto: ExecuteActionDto,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/devices/v1/clients/${clientId}/devices/${deviceId}/execute-remote/${remoteActionPointId}`,
      executeActionDto,
    );
  }
  /**
   * @summary Pause a device
   */

  pause<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerPausePathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/pause`, undefined);
  }
  /**
   * @summary Activate a device
   */

  activate<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerActivatePathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/activate`, undefined);
  }
  /**
   * @summary Archive a device
   */

  archive<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, deviceId }: DevicesControllerArchivePathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/archive`, undefined);
  }
  /**
   * @summary Deactivate a device
   */

  deactivate<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: DevicesControllerDeactivatePathParameters): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/devices/${deviceId}/deactivate`, undefined);
  }
}
